import React, { Component } from "react";
import { isCallService } from "../../common/scripts/services";
import Mensajes from "../../common/scripts/mensajes";

export default class PostulacionVacunaForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nombre: "",
      idList: [],
      documentSelected: {
        CSDocumentoIdentidadText: "elija un documento",
      },
      numeroDocumento: "",
      celular: "",
      telefonoFijo: "",
      email: "",
      esPoblacionFaseActual: false,
      poblacionEntre_N_y_X_edad: true,
      opcionesParaPostulacionDeVacuna: [],
      emailIsValid: null,
      archivo: null,
      tamanoArchivo: 0,
      consentimiento: false,
      visibleSelectoridList: false,
    };
    this.handleInput = this.handleInput.bind(this);
    this.handleChecked = this.handleChecked.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    postulacionVacunaOptions.map((item, index) => {
      item.isSelected = false;
      return item;
    });
    this.setState({
      opcionesParaPostulacionDeVacuna: postulacionVacunaOptions,
    });
  }

  handleChecked(option, index) {
    let newOptions = this.state.opcionesParaPostulacionDeVacuna;
    newOptions[index].isSelected = !newOptions[index].isSelected;
    this.setState({ opcionesParaPostulacionDeVacuna: newOptions });
  }
  chechkingBoxes() {}
  handleInput(event) {
    let regexNombre = /[^a-z A-Z]+/g;
    let regexNumber = /\D+/g;
    let regexAlfaNum = /[^a-z A-Z0-9]+/g;
    let idDoc = this.state.documentSelected.CSIdDocumentoText;
    switch (event.target.name) {
      case "nombre":
        let newNombre = event.target.value.replace(regexNombre, "");
        this.setState({ nombre: newNombre });
        break;
      case "numeroDocumento":
        let numeroDocumento =
          idDoc == 5 ||
          idDoc == 6 ||
          idDoc == 8 ||
          idDoc == 10 ||
          idDoc == 11 ||
          idDoc == 12 ||
          idDoc == 13
            ? event.target.value.replace(regexAlfaNum, "")
            : event.target.value.replace(regexNumber, "");
        this.setState({ numeroDocumento: numeroDocumento });
        break;
      case "celular":
        this.setState({ celular: event.target.value.replace(regexNumber, "") });
        break;
      case "telefonoFijo":
        this.setState({
          telefonoFijo: event.target.value.replace(regexNumber, ""),
        });
        break;
      case "email":
        let isValid = this.validateEmail(event.target.value);
        this.setState({ email: event.target.value, emailIsValid: isValid });
        break;
      case "files":
        for (let i = 0; i < event.target.files.length; i++) {
          let file = event.target.files[i];
          this.getBase64(file);
        }
        break;
      default:
        break;
    }
  }

  getBase64(file) {
    var reader = new FileReader(); // posible leak de memoria
    reader.readAsDataURL(file);
    reader.onload = () => {
      let newFile = reader.result.split(",");
      this.setState({
        archivo: newFile[1],
        tamanoArchivo: file.size,
        extensionArchivo: file.type.split("/"),
      });
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  }

  validateEmail(email) {
    var re =
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/gim;
    return re.test(email);
  }

  handleSubmit() {
    let opciones = this.state.opcionesParaPostulacionDeVacuna.map((item) => {
      let data = { NombreInternoCampo: item.column, Valor: item.isSelected };
      return data;
    });
    opciones.push({ NombreInternoCampo: "Email", Valor: this.state.email });
    opciones.push({
      NombreInternoCampo: "NombreCompleto",
      Valor: this.state.nombre,
    });
    opciones.push({
      NombreInternoCampo: "TipoDocumento",
      Valor: this.state.documentSelected.CSSiglaText,
    });
    opciones.push({
      NombreInternoCampo: "NumeroDocumento",
      Valor: this.state.numeroDocumento,
    });
    opciones.push({ NombreInternoCampo: "Celular", Valor: this.state.celular });
    opciones.push({ NombreInternoCampo: "AceptoTerminos", Valor: true });
    opciones.push({
      NombreInternoCampo: "Telefono",
      Valor: this.state.telefonoFijo,
    });
    opciones.push({
      NombreInternoCampo: "PoblacionFaseActual",
      Valor: this.state.esPoblacionFaseActual
        ? `Población fase ${i18next.t("forms.faseActual")}`
        : "",
    });
    opciones.push({
      NombreInternoCampo: "PoblacionEntre_N_y_X_edad",
      Valor: this.state.poblacionEntre_N_y_X_edad
        ? `Población entre ${rangoEdadPostulacionVacuna[0]} y ${rangoEdadPostulacionVacuna[1]} años`
        : "",
    });
    let data = {
      Accion: "ADD",
      Lista: "TemasCovid19-PostulacionVacuna",
      UrlSitio: window.location.origin + "/salud/transacciones",
      Campos: {
        Valores: opciones,
      },
    };
    ///AAAAMMDD-HHMM         -ID-NDOCUMENTO.extension
    this.state.poblacionEntre_N_y_X_edad
      ? (data.NameBase64 = `${moment().format("DDMMYYYY")}-${moment().format(
          "HHmm"
        )}-${this.state.documentSelected.CSSiglaText}-${
          this.state.numeroDocumento
        }.${this.state.extensionArchivo[1]}`)
      : null;
    this.state.poblacionEntre_N_y_X_edad
      ? (data.Base64 = this.state.archivo)
      : null;
    this.props.handleSubmit(data);
  }

  getNombre(event) {
    event.preventDefault();
    let data = {
      TipoDocumento: this.state.documentSelected.CSIdDocumentoText,
      NumeroDocumento: this.state.numeroDocumento,
      // Opcion: "34",
      // TiempoCache: 1440,
      // FiltrarGrupoFamiliar: false,
      TiempoCache: 120,
    };
    isCallService({
      // loadingElement: '',
      service: "ObtenerRiesgosUsuario",
      params: data,
      changeState: "riesgos",
      executeCallback: (result) => {
        if (result.Observaciones !== "No existe Afiliado") {
          this.setState({ nombre: result.Nombre, sinUsuario: null });
          // this.handleData();
          return;
        }
        this.setState({ sinUsuario: true });
      },
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
  }

  // handleSubmit(event) {
  //     event.preventDefault();
  //     let data = {
  //         "TipoDocumento": this.state.documentSelected.CSIdDocumentoText,
  //         "NumeroDocumento": this.state.numeroDocumento,
  //         "Opcion": "34",
  //         "TiempoCache": 1440,
  //         "FiltrarGrupoFamiliar": false
  //     }
  //     isCallService({
  //         // loadingElement: '',
  //         service: 'ObtenerRiesgosUsuario',
  //         params: data,
  //         changeState: 'riesgos',
  //         executeCallback: (result) => {
  //             if (result.Observaciones !== "No existe Afiliado") {
  //                 this.setState({ nombre: result.Nombre, sinUsuario: null })
  //                 this.handleData();
  //                 return
  //             }
  //             this.setState({ sinUsuario: true })
  //         },
  //         error: "error",
  //         condition: true,
  //         showLogs: false,
  //         mainObject: this
  //     })
  // }

  handleGenericHtml(data) {
    return { __html: data };
  }

  render() {
    let [
      nombre,
      idList,
      idNum,
      celular,
      telefono,
      poblacionNXedad,
      email,
      emailIsValid,
      archivo,
    ] = [
      this.state.nombre,
      this.props.idList,
      this.state.numeroDocumento,
      this.state.celular,
      this.state.telefonoFijo,
      this.state.poblacionEntre_N_y_X_edad,
      this.state.email,
      this.state.emailIsValid,
      this.state.archivo,
    ];

    return (
      <section style={{ marginTop: "40px" }}>
        <hr />
        <div
          dangerouslySetInnerHTML={this.handleGenericHtml(
            i18next.t("forms.subtituloFormularioPostulacionVacuna")
          )}
        />
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="form-group row">
            <div className="col-sm-4">
              <p className="col-form-label formularioSolicitud--text-aligned formularioSolicitud--label">
                Documento de identidad*
              </p>
              <p className="formularioSolicitud--text-aligned">
                {i18next.t("forms.cedulaIndicacion")}
              </p>
            </div>
            <div className="col-sm-3">
              <button
                disabled={false}
                style={{ cursor: "pointer" }}
                className="dropdown-toggle formularioSolicitud--dropDown"
                // type="button"
                id="dropdownCedula"
                // data-toggle="dropdown"
                // aria-haspopup="true"
                // aria-expanded="true"
                onClick={() =>
                  this.setState({
                    visibleSelectoridList: !this.state.visibleSelectoridList,
                  })
                }
              >
                <div>
                  <p className="text-left">
                    {this.state.documentSelected.CSDocumentoIdentidadText}
                  </p>
                </div>
                <span className="caret"></span>
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownCedula"
                style={{
                  cursor: "pointer",
                  display: `${
                    this.state.visibleSelectoridList ? "block " : "none"
                  }`,
                }}
              >
                {idList.map((item, index) => {
                  return (
                    <li
                      key={index}
                      onClick={() =>
                        this.setState({
                          documentSelected: item,
                          visibleSelectoridList: false,
                        })
                      }
                    >
                      <p>{item.CSDocumentoIdentidadText}</p>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="col-sm-5">
              <input
                style={{ cursor: "pointer" }}
                disabled={false}
                type="text"
                className={
                  idNum == "" || idNum == " "
                    ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                    : "form-control formularioSolicitud--input"
                }
                value={idNum}
                onChange={() => this.handleInput(event)}
                onBlur={(e) => this.getNombre(e)}
                name="numeroDocumento"
                maxLength={33}
              />
              {idNum == "" ||
                idNum == " " ||
                (idNum == null && (
                  <p className="formularioSolicitud--input-errorLabel">
                    {i18next.t("forms.cedulaError")}
                  </p>
                ))}
            </div>
          </div>

          <div className="form-group row">
            <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
              {i18next.t("forms.nombre")}
            </label>
            <div className="col-sm-8">
              <input
                style={{ cursor: "pointer" }}
                type="text"
                className={
                  nombre == "" || nombre == " "
                    ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                    : "form-control formularioSolicitud--input"
                }
                value={nombre}
                onChange={() => this.handleInput(event)}
                // onBlur={() => this.handleInput(event)}
                name="nombre"
              />
              {nombre == "" ||
                nombre == " " ||
                (nombre == null && (
                  <p className="formularioSolicitud--input-errorLabel">
                    {i18next.t("forms.nombreError")}
                  </p>
                ))}
            </div>
          </div>

          <div className="form-group row">
            <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
              {i18next.t("forms.telefono")}
            </label>
            <div className="col-sm-8">
              <input
                style={{ cursor: "pointer" }}
                type="text"
                className={
                  celular == "" || celular == " "
                    ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                    : "form-control formularioSolicitud--input"
                }
                value={celular}
                onChange={() => this.handleInput(event)}
                name="celular"
                maxLength={13}
              />
              {celular == "" ||
                celular == " " ||
                (celular == null && (
                  <p className="formularioSolicitud--input-errorLabel">
                    {i18next.t("forms.telefonoError")}
                  </p>
                ))}
            </div>
          </div>

          <div className="form-group row">
            <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
              {i18next.t("forms.telefonoFijo")}
            </label>
            <div className="col-sm-8">
              <input
                style={{ cursor: "pointer" }}
                type="text"
                className={
                  telefono == "" || telefono == " "
                    ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                    : "form-control formularioSolicitud--input"
                }
                value={telefono}
                onChange={() => this.handleInput(event)}
                name="telefonoFijo"
                maxLength={13}
              />
              {/* {telefono == "" || telefono == " " || telefono == null ? <p className="formularioSolicitud--input-errorLabel">{i18next.t("forms.telefonoFijoError")}</p> : null} */}
            </div>
          </div>

          <div className="form-group row">
            <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
              {i18next.t("forms.email")}
            </label>
            <div className="col-sm-8">
              <input
                style={{ cursor: "pointer" }}
                type="text"
                className={
                  email == "" || email == " "
                    ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                    : "form-control formularioSolicitud--input"
                }
                value={email}
                onChange={() => this.handleInput(event)}
                onFocus={() => this.handleInput(event)}
                name="email"
              />
              {email == "" ||
                email == " " ||
                email == null ||
                (emailIsValid == false && (
                  <p className="formularioSolicitud--input-errorLabel">
                    {i18next.t("forms.emailError")}
                  </p>
                ))}
            </div>
          </div>

          {/* {!this.state.poblacionEntre_N_y_X_edad && false && ( */}
          {false && (
            <div className="form-group row ">
              <label className="col-sm-12 col-form-label formularioSolicitud--text-aligned ">
                {i18next.t("forms.formVacunaPreguntaEtapa")}
              </label>
              <div className="col-sm-12 col-form-label formularioSolicitud--text-aligned">
                <div className="cotizar-form-controls">
                  <button
                    onChange={(event) => {
                      event.preventDefault();
                      this.setState({
                        esPoblacionFaseActual:
                          !this.state.esPoblacionFaseActual,
                      });
                    }}
                    className={`cotizar-form-controls-action ${
                      this.state.esPoblacionFaseActual ? "active" : null
                    }`}
                  >
                    Si
                  </button>
                  <button
                    onChange={(event) => {
                      event.preventDefault();
                      this.setState({
                        esPoblacionFaseActual:
                          !this.state.esPoblacionFaseActual,
                      });
                    }}
                    className={`cotizar-form-controls-action ${
                      !this.state.esPoblacionFaseActual ? "active" : null
                    }`}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          )}

          {!this.state.esPoblacionFaseActual && (
            <div className="form-group row">
              <label className="col-sm-12 col-form-label formularioSolicitud--text-aligned">
                {i18next.t("forms.formVacunaPreguntaRangoEdad")}
              </label>
              {false && (
                <div className="col-sm-12 col-form-label formularioSolicitud--text-aligned ">
                  <div className="cotizar-form-controls">
                    <button
                      onChange={(event) => {
                        event.preventDefault();
                        this.setState({
                          poblacionEntre_N_y_X_edad: !poblacionNXedad,
                        });
                      }}
                      className={`cotizar-form-controls-action ${
                        poblacionNXedad ? "active" : null
                      }`}
                    >
                      Si
                    </button>
                    <button
                      onChange={(event) => {
                        event.preventDefault();
                        this.setState({
                          poblacionEntre_N_y_X_edad: !poblacionNXedad,
                        });
                      }}
                      className={`cotizar-form-controls-action ${
                        !poblacionNXedad ? "active" : null
                      }`}
                    >
                      No
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}

          {this.state.poblacionEntre_N_y_X_edad && (
            <div className="form-group row animate__animated animate__fadeIn">
              <div className="col-sm-12 col-form-label formularioSolicitud--text-aligned ">
                {this.state.opcionesParaPostulacionDeVacuna.map(
                  (item, index) => {
                    return (
                      <div key={index} className="form-check form-check-inline">
                        <label className="form-check-label">{item.label}</label>
                        <br />
                        <input
                          style={{ cursor: "pointer" }}
                          onClick={() => this.handleChecked(item, index)}
                          checked={item.isSelected}
                          className="form-check-input"
                          type="checkbox"
                        />
                        <hr className="form-group_divisorLine" />
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          )}

          {this.state.poblacionEntre_N_y_X_edad && (
            <div className="form-group row">
              <label className="col-sm-5 col-form-label formularioSolicitud--text-aligned">
                {i18next.t("forms.subidaArchivo")}
              </label>
              <div className="col-sm-7">
                <input
                  style={{ cursor: "pointer" }}
                  type="file"
                  className={
                    archivo == "" || archivo == " "
                      ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                      : "form-control formularioSolicitud--input"
                  }
                  onChange={(event) => this.handleInput(event)}
                  name="files"
                  accept="application/pdf,image/*"
                />
                {this.state.tamanoArchivo > 4999999 && (
                  <p className="formularioSolicitud--input-errorLabel">
                    {i18next.t("forms.errorArchivo")}
                  </p>
                )}
              </div>
            </div>
          )}
          <div className="form-group row">
            <label className="col-sm-12 col-form-label formularioSolicitud--text-aligned">
              {i18next.t("forms.preguntaConsentimiento")}
            </label>
            <div className="col-sm-12 col-form-label formularioSolicitud--text-aligned ">
              <div className="cotizar-form-controls">
                <button
                  onClick={(event) => {
                    event.preventDefault();
                    this.setState({ consentimiento: true });
                  }}
                  className={`cotizar-form-controls-action ${
                    this.state.consentimiento ? "active" : null
                  }`}
                >
                  Si
                </button>
                <button
                  onClick={(event) => {
                    event.preventDefault();
                    this.setState({ consentimiento: false });
                  }}
                  className={`cotizar-form-controls-action ${
                    this.state.consentimiento === false ? "active" : null
                  }`}
                >
                  No
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 text-center">
              <button
                type="button"
                className="btn btn-default"
                onClick={() => this.handleSubmit()}
                disabled={
                  nombre === "" ||
                  nombre === " " ||
                  idNum === "" ||
                  idNum === " " ||
                  celular === "" ||
                  celular === " " ||
                  emailIsValid == false ||
                  this.state.consentimiento === false ||
                  this.state.opcionesParaPostulacionDeVacuna.every(
                    (x) => x.isSelected === false
                  ) ||
                  (this.state.tamanoArchivo > 4999999 &&
                    this.state.poblacionEntre_N_y_X_edad) ||
                  (this.state.tamanoArchivo === 0 &&
                    this.state.poblacionEntre_N_y_X_edad)
                }
              >
                {i18next.t("buttons.priorizacionFormButton")}
              </button>
            </div>
          </div>
        </form>

        <Mensajes
          showModal={this.state.error}
          closeModal={() => this.setState({ error: false })}
          MessageTitle={i18next.t("modales.tituloError")}
          Icono={"fa fa-times-circle-o"}
          colorIco={"red"}
          msg={
            this.state.sinUsuario
              ? i18next.t("modales.sinUsuario")
              : i18next.t("modales.error")
          }
          AltButtonAction={() => this.setState({ error: false })}
          AltButtonText={i18next.t("modales.buttonAceptar")}
        />
      </section>
    );
  }
}
